// The point of this component is to handle FamilyAccess requests
// and pass that data down to its children as props.

import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';

// Redux
import { connect } from 'react-redux';
import {
  closeAlertDialog,
  closeConfirmDialog,
  openConfirmDialog,
  openErrorDialog,
  openSuccessDialog,
} from '../../../../actions/dialog/dialogActions';
import {
  deleteUser,
  disableUser,
  createUser,
  enableUser,
  getAccessUsers,
  grantUserAccess,
  removeExpiration,
  updateExpiration,
} from '../../../../actions/familyAccess/familyAccessActions';
import { GET_ACCESS_USERS } from '../../../../actions/familyAccess/types';

import LoadingState from '../../../LoadingState';
import AccessManagement from '../AccessManagement';
import CreateNewUser from '../CreateNewUser';
import GrantUserAccess from '../GrantUserAccess';

import s from './FamilyAccess.css';


export class FamilyAccessContainer extends Component {
  static propTypes = {
    closeAlertDialog: func,
    closeConfirmDialog: func,
    createUser: func,
    deleteUser: func,
    disableUser: func,
    enableUser: func,
    familyAccess: object,
    getAccessUsers: func,
    grantUserAccess: func,
    loading: object,
    openConfirmDialog: func,
    openErrorDialog: func,
    removeExpiration: func,
    updateExpiration: func,
  };

  componentDidMount() {
    this.getAccessUsers();
  }

  // This function is passed down as a prop. A child component calls this when
  // a CRUD action on a User is invoked
  getAccessUsers = () => this.props.getAccessUsers();

  render = () => {
    const loading = contains(GET_ACCESS_USERS, this.props.loading.requests);

    if (loading) {
      return (
        <div className={s.component}>
          <p className={s.message}>
            Loading Family Access Users...
          </p>
          <LoadingState context="familyAccess" />
        </div>
      );
    } else {
      return (
        <div className={s.component}>
          <AccessManagement
            accessUsers={this.props.familyAccess.users}
            closeConfirmDialog={this.props.closeConfirmDialog}
            closeAlertDialog={this.props.closeAlertDialog}
            deleteUser={this.props.deleteUser}
            disableUser={this.props.disableUser}
            enableUser={this.props.enableUser}
            openErrorDialog={this.props.openErrorDialog}
            openSuccessDialog={this.props.openSuccessDialog}
            handleRefreshUsers={this.getAccessUsers}
            openConfirmDialog={this.props.openConfirmDialog}
            removeExpiration={this.props.removeExpiration}
            updateExpiration={this.props.updateExpiration}
          />
          <CreateNewUser
            createUser={this.props.createUser}
          />
          <GrantUserAccess
            grantUserAccess={this.props.grantUserAccess}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  loading: state.loadingState,
  familyAccess: state.familyAccess,
});

const mapDispatchToProps = dispatch => ({
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  createUser: (formValues) => dispatch(createUser(formValues)),
  deleteUser: (userId, successCb, errorCb) => dispatch(deleteUser(userId, successCb, errorCb)),
  disableUser: (userId, successCb, errorCb) => dispatch(disableUser(userId, successCb, errorCb)),
  enableUser: (userId, successCb, errorCb) => dispatch(enableUser(userId, successCb, errorCb)),
  getAccessUsers: () => dispatch(getAccessUsers()),
  grantUserAccess: (formValues) => dispatch(grantUserAccess(formValues)),
  openConfirmDialog: dialog => dispatch(openConfirmDialog(dialog)),
  openErrorDialog: dialog => dispatch(openErrorDialog(dialog)),
  openSuccessDialog: dialog => dispatch(openSuccessDialog(dialog)),
  removeExpiration: (id, successCb, errorCb) => dispatch(removeExpiration(id, successCb, errorCb)),
  updateExpiration: (data, successCb, errorCb) => dispatch(updateExpiration(data, successCb, errorCb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FamilyAccessContainer);



// WEBPACK FOOTER //
// ./src/components/Pages/Account/FamilyAccess/FamilyAccessContainer.js